import { render, staticRenderFns } from "./Main.vue?vue&type=template&id=4ea4c871&scoped=true&"
import script from "./Main.vue?vue&type=script&lang=js&"
export * from "./Main.vue?vue&type=script&lang=js&"
import style0 from "./Main.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./Main.vue?vue&type=style&index=1&id=4ea4c871&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ea4c871",
  null
  
)

export default component.exports